import { render } from "./TheVehicleRentals.vue?vue&type=template&id=1f38a0cc"
import script from "./TheVehicleRentals.vue?vue&type=script&lang=js"
export * from "./TheVehicleRentals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__